// extracted by mini-css-extract-plugin
export default {"card":"GrayCardWithVerticalDivider_card__u2jjj","title-container":"GrayCardWithVerticalDivider_title-container__tG+bj","divider":"GrayCardWithVerticalDivider_divider__tB0qW"};